/**=========================================================
 * Module: app-form.js
 * Handles form plugin and validation
 =========================================================*/

App.directive('appForm', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/form.html',
      controller: 'FormController',
      restrict: 'E',
      replace: true,
      scope: { form: '=form' }
  };

});
